import _ from 'underscore';
import jQuery from 'jquery';
let GeoJSON = require('geojson');

export default class Utils {

  static convertToGeoJSON(places) {
    places.forEach((data) => {
      data.lat = data.geometry.location ? data.geometry.location.lat() : data.geometry[1];
      data.lng = data.geometry.location ? data.geometry.location.lng() : data.geometry[0];
    });
    return GeoJSON.parse(places, {
      Point: ['lat', 'lng']
    });
  }
  static transformDataToGeoJSON(results, opt) {
    if (this.isGeoJSON(results)) {
      return results;
    } else {

      results.features.forEach((feature) => {
        let featureProp = _.chain(feature).value();
        feature = featureProp;
        feature.id = featureProp[opt.featureId];
        let geom = featureProp[opt.geometry];
        let lon, lat;
        if (!geom && opt.geometry.lon && opt.geometry.lat) {
          lon = featureProp[opt.geometry.lon];
          lat = featureProp[opt.geometry.lat];
        } else if (_.isArray(geom)) {
          lon = geom[0];
          lat = geom[1];
        } else if (_.isObject(geom)) {
          lon = geom.lon;
          lat = geom.lat;
        }
        feature.geometry = [lon, lat];
      });
    }
    return this.convertToGeoJSON(results.features);
  }

  static isGeoJSON(results) {
    let isValidGeoJson;
    results.features.forEach((feature) => {
      if (feature.geometry && feature.type === 'Feature') {
        isValidGeoJson = true;
      } else {
        return false;
      }
    });

    return isValidGeoJson;
  }
  static convertFeaturesToLatLng(features) {
    let arrResults = [];
    features.forEach((feature) => {
      arrResults.push(new google.maps.LatLng(feature.geometry.coordinates[1], feature.geometry.coordinates[0]));
    });
    return arrResults;
  }

  static getPreloadedJson(_path) {
    let path = _path.replace(new RegExp('.json$'), '').replace(new RegExp('^./data/'), ''),
      json = require('../../../src/data/' + path + '.json');
    return json;
  }

  static getPolygonPath(feature) {
    let coords = feature.geometry.coordinates,
      paths;
    if (coords.length > 1) {
      paths = _.map(coords, (entry) => {
        return _.reduce(entry, (list, polygon) => {
          _.each(_.map(polygon, (point) => {
            return new google.maps.LatLng(
              point[1], point[0]);
          }), (point) => {
            list.push(point);
          });
          return list;
        }, []);
      });
    } else {
      paths = _.map(coords[0], (point) => {
        return new google.maps.LatLng(
          point[1], point[0]);
      });
    }
    return paths;
  }

  static createPolygons(feature) {
    let paths, polygon;
    if (feature.geometry.type === 'MultiPolygon' || feature.geometry.type === 'Polygon') {
      paths = this.getPolygonPath(feature);
    }

    polygon = new google.maps.Polygon({
      paths: paths
    });
    return polygon;
  }

  static requestUserPosition() {
    let deferred = jQuery.Deferred();
    if (this.userPosition) {
      deferred.resolve(this.userPosition);
    } else if (this.ieGeolocationCancelled) {
      deferred.reject();
    } else if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.userPosition = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
        deferred.resolve(this.userPosition);
      }, (error) => {
        deferred.reject(error);
        let browser = this.getBrowser();
        if (browser.name === 'IE' || browser.name === 'Edge') {
          this.ieGeolocationCancelled = true;
        }
      });
    } else {
      deferred.reject();
    }
    return deferred.promise();
  }

  static getDateFromString(date) {
    let dateArray = date.split('/');
    return new Date(dateArray[1] + '/' + dateArray[0] + '/' + dateArray[2]);
  }

  static getStringFromDate(date) {
    return (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + '/' + (date.getMonth() <
      10 ? '0' + date.getMonth() : date.getMonth()) + '/' + date.getFullYear();
  }

  static getTimeFromDate(date) {
    return (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':' + (date.getMinutes() < 10 ? '0' +
      date.getMinutes() : date.getMinutes());
  }

  static getImgUrl(url, widget, extraFolder) {
    let _url = null;
    if (url.indexOf('http') > -1) {
      _url = url;
    } else {
      let folder = extraFolder ? extraFolder + '/' : '';
      let path = widget.config.imagesPath ? widget.config.imagesPath : '../images/';
      let suffix = widget.config.imagesSuffix ? widget.config.imagesSuffix : '';
      _url = path + folder + url + suffix;
    }
    return _url;
  }

  static getBrowser() {
    var ua = navigator.userAgent,
      tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return {
        name: 'IE',
        version: (tem[1] || '')
      };
    }
    if (/Edge\/\d./i.test(ua)) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return {
        name: 'Edge',
        version: (tem[1] || '')
      };
    }
    if (M[1] === 'Chrome') {
      tem = ua.match(/\bOPR\/(\d+)/);
      if (tem !== null) {
        return {
          name: 'Opera',
          version: tem[1]
        };
      }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) !== null) { M.splice(1, 1, tem[1]); }
    return {
      name: M[0],
      version: M[1]
    };
  }

  static queryStringToObject(qString) {
    let qProcess = qString.split('&');
    let qObject = {};
    for (let i = 0; i < qProcess.length; i++) {
      let el = qProcess[i].split('=');
      qObject[el[0]] = el[1];
    }
    return qObject;
  }

  static queryObjectToString(qObject) {
    let qString = '';
    for (let k in qObject) {
      if (qObject.hasOwnProperty(k)) {
        qString += k + ':' + qObject[k] + '?';
      }
    }
    return qString;
  }

  static createMessage(type, text, autohide = false, repeatable = false, msgId = undefined) {
    let config = {
      type: type,
      text: text,
      autohide: autohide,
      repeatable: repeatable,
      msgId: msgId
    };
    return config;
  }

  static createLinkToMessage(errorText, url) {
    let textResult = '',
      textComponents = errorText.split('/link/');
    textResult = textComponents[0];
    if (textComponents[1].length > 0) {
      textResult += `<a href="${url}" class="lmm-msg-link lmm-link" target="_blank">${textComponents[1]}</a>`;
    }
    if (textComponents[2].length > 0) {
      textResult += textComponents[2];
    }
    return textResult;
  }

  static sortBy(array, sortBy = 'order') {
    return _.sortBy(_.map(array, (item, key) => {
      item.id = item.id || key;
      return item;
    }), sortBy) || [];
  }

  /**
   * Formats a text to a lmm css className.
   * @param {String} text - The text to format
   */
  static formatCssClass(text) {
    let prefix = 'lmm-',
      textLowerCase = [];
    _.each(text.split(/(?=[A-Z])/), (e) => {
      textLowerCase.push(e.toLowerCase());
    });
    return prefix + textLowerCase.join('-');
  }

  /**
   * @param  {String} template
   * @param  {String[]} values
   * @return {String}
   */
  static stringFormat(template, values) {
    return template.replace(/%s/g, function() {
      return values.shift();
    });
  }

  /**
   * Gets the distance between to points in the map.
   * @param {object} p1 - Start position for the distance calculation, as an object containing lat and lng fields
   * @param {object} p2 - End position for the distance calculation, as an object containing lat and lng fields
   * @returns {Float} The distance in meters between the two points
   */
  static getDistance(p1, p2) {
    let R = 6378137,
      a, c, d, // Earth’s mean radius in meter
      rad = function(x) {
        return x * Math.PI / 180;
      },
      dLat = rad(+p2.lat - +p1.lat),
      dLong = rad(+p2.lng - +p1.lng);

    a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(rad(+p1.lat)) * Math.cos(rad(+p2.lat)) *
      Math.sin(dLong / 2) * Math.sin(dLong / 2);
    c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    d = R * c;
    return d; // returns the distance in meter
  }

  /**
   * Gets the bounding box from a point using a radius.
   * @param {google.maps.LatLng} point - Center point used to calculate the bounding box
   * @param {Number} radius - Distance from the point to calculate the bounding
   * @returns {google.maps.LatLngBounds} bounding box object 
   */
  static getBoundsFromPoint(point, radius) {
    let circle = new google.maps.Circle({
      center: point,
      radius: radius
    });
    return circle.getBounds();
  }

  static _loadCartoLibraries() {
    let deferred = jQuery.Deferred();
    let promises = [];
    promises.push(this._loadjscssfile(
      'https://cartodb-libs.global.ssl.fastly.net/cartodb.js/v3/3.15/cartodb.js',
      'js'));
    promises.push(this._loadjscssfile(
      'https://cartodb-libs.global.ssl.fastly.net/cartodb.js/v3/3.15/themes/css/cartodb.css',
      'css'));

    jQuery.when.apply(jQuery, promises)
      .then(() => {
        deferred.resolve();
      }).fail((reason) => {
        deferred.reject(reason);
      });
    return deferred.promise();
  }
  static _loadjscssfile(filesrc, filetype) {
    this.libsPromises = this.libsPromises || {};
    if (this.libsPromises[filesrc]) {
      return this.libsPromises[filesrc];
    }
    let deferred = jQuery.Deferred();
    let promise = deferred.promise();
    this.libsPromises[filesrc] = promise;
    let fileref = null;
    if (filetype === 'js') {
      fileref = document.createElement('script');
      fileref.setAttribute('type', 'text/javascript');
      fileref.setAttribute('src', filesrc);
    } else if (filetype === 'css') {
      fileref = document.createElement('link');
      fileref.setAttribute('rel', 'stylesheet');
      fileref.setAttribute('type', 'text/css');
      fileref.setAttribute('href', filesrc);
    }
    if (typeof fileref !== 'undefined') {
      fileref.onload = () => {
        deferred.resolve();
      };
      document.getElementsByTagName('head')[0].appendChild(fileref);
    }
    return promise;
  }

  static debounce(func, wait, immediate) {
    let timeout;
    return function() {
      let _this = this,
        args = arguments;
      let later = function() {
        timeout = null;
        if (!immediate) { func.apply(_this, args); }
      };
      let callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) {
        func.apply(_this, args);
      }
    };
  }
}



// WEBPACK FOOTER //
// ./lmm-widget/src/helpers/Utils.js